import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { ASSETS_KEYS } from '../../../constants';
import utils from '../../../utils';
var sliceName = 'ASSETS_PACKAGE';
var initialState = {
  data: [],
  errorMsg: '',
  assetsPackageId: null,
  lastRevisionNumber: {},
  assetsLoaded: false,
  assets: {}
};
var assetsPackageSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    assetsPackageRequestError: function assetsPackageRequestError(state, action) {
      state.errorMsg = action.payload;
    },
    assetsPackageRequestDataSuccess: function assetsPackageRequestDataSuccess(state, action) {
      state.data = action.payload;
      var itemKeys = Object.keys(action.payload.items);
      var itemValues = Object.values(action.payload.items);

      for (var j = 0; j < itemKeys.length; j++) {
        for (var z = 0; z < Object.keys(ASSETS_KEYS).length; z++) {
          if (itemKeys[j] === Object.values(ASSETS_KEYS)[z]) {
            state.assets = _objectSpread(_objectSpread({}, state.assets), {}, _defineProperty({}, action.payload.assetsPackageCategory, _objectSpread(_objectSpread({}, state.assets[action.payload.assetsPackageCategory]), {}, _defineProperty({}, Object.keys(ASSETS_KEYS)[z], utils.getPlatform() === 'web' ? "".concat(action.payload.baseUrl).concat(itemKeys[j], "?revision=").concat(itemValues[j]) : {
              uri: "".concat(action.payload.baseUrl).concat(itemKeys[j], "?revision=").concat(itemValues[j])
            }))));
          }
        }
      }
    },
    setAssetsLoaded: function setAssetsLoaded(state, action) {
      state.assetsLoaded = action.payload;
    },
    setStockControl: function setStockControl(state, action) {
      state.assetsPackageId = action.payload.assetsPackageId;
      state.lastRevisionNumber = action.payload.lastRevisionNumber;
    }
  }
});
var actions = assetsPackageSlice.actions,
    reducer = assetsPackageSlice.reducer;
var assetsPackageRequestError = actions.assetsPackageRequestError,
    assetsPackageRequestDataSuccess = actions.assetsPackageRequestDataSuccess,
    setAssetsLoaded = actions.setAssetsLoaded,
    setStockControl = actions.setStockControl;
export { assetsPackageRequestError, assetsPackageRequestDataSuccess, setAssetsLoaded, setStockControl };
export default reducer;